import {
  formatData,
  getCodEmpresa,
  getCodUsuarioRegistrou
} from 'lib/functions';
import {
  AppBar,
  Backdrop,
  Box,
  Button,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography
} from '@material-ui/core';
import {
  BackspaceOutlined,
  CropFreeRounded,
  ExitToApp,
  FilterListRounded,
  Search,
  SendRounded,
  WhatsApp
} from '@material-ui/icons';
import api from 'services/api';
import PropTypes from 'prop-types';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getApiErrorMessage, getResponseData } from 'lib/formUtils';

function TabContainer(props) {
  return (
    <Typography
      component="div"
      style={{ padding: 8 * 3 }}
    >
      {props.children}
    </Typography>
  );
};

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

/* Propriedades padrão dos labels dos filtros de data / hora */
const LABEL_PROPS_FILTRO = {
  shrink: true,
  style: { fontSize: 13 }
};

/* Estilo dos grupos de data / hora do período */
const ESTILO_GRUPO_PERIODO = {
  display: 'flex',
  gap: 10,
  flexWrap: 'nowrap',
  whiteSpace: 'nowrap'
};

/* Campos de período da pesquisa (agrupados em data + hora) */
const GRUPOS_PERIODO = [
  [
    {
      name: 'dataInicialFilter',
      label: 'Data Inicial',
      type: 'date'
    },
    {
      name: 'horaInicialFilter',
      label: 'Hora Inicial',
      type: 'time'
    }
  ],
  [
    {
      name: 'dataFinalFilter',
      label: 'Data Final',
      type: 'date'
    },
    {
      name: 'horaFinalFilter',
      label: 'Hora Final',
      type: 'time'
    }
  ]
];

/* Categorias de fornecedores do filtro */
const CATEGORIAS = [
  {
    name: 'guiaFilter',
    label: 'Guias'
  },
  {
    name: 'fornecTranspFilter',
    label: 'Fornecedores de Transporte'
  },
  {
    name: 'motoristaFilter',
    label: 'Motoristas'
  }
];

/* Propriedades dos combos dos filtros */
const PROPS_COMBO_FILTRO = {
  openOnFocus: true,
  disablePortal: true
};

/* Estilo das células do cabeçalho da tabela */
const ESTILO_CABECALHO = {
  backgroundColor: '#fafafa',
  paddingTop: 4,
  paddingBottom: 4
};

/* Colunas da tabela de fornecedores (após a coluna de seleção) */
const COLUNAS_ESCALAS = [
  'Categoria',
  'Fornecedor',
  'Fone',
  'Escala',
  'Data serviço',
  'Serviço',
  'Status',
  'Grupo de mensagens'
];

/* Cores do status de envio (1 = enviado, 2 = recebido) */
const COR_STATUS = {
  1: 'black',
  2: 'green'
};

/* Legenda dos status de envio */
const LEGENDA_STATUS = [
  {
    label: 'Não enviado',
    backgroundColor: 'white',
    border: '1px solid #ccc'
  },
  {
    label: 'Enviado',
    backgroundColor: 'black'
  },
  {
    label: 'Recebido',
    backgroundColor: 'green'
  }
];

/* Estilo do Backdrop de carregamento (limitado a este componente) */
const ESTILO_BACKDROP = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  color: '#3f51b5',
  zIndex: 1301,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(244, 246, 248, 0.7)'
};

/* Retorna a descrição do fornecedor no combo */
const getFornecedorLabel = (option) => option.fantasia || '';

/* Retorna a descrição do serviço no combo */
const getServicoLabel = (option) => option.descservico || '';

/* Retorna o nome do grupo de mensagens no combo */
const getGrupoLabel = (option) => option.nome || '';

/* Retorna os filtros de pesquisa padrão */
function getSearchFilterDefault() {
  return {
    tipoDataFilter: 1,
    dataInicialFilter: '',
    horaInicialFilter: '00:00',
    dataFinalFilter: '',
    horaFinalFilter: '23:59',
    guiaFilter: ASIM,
    fornecTranspFilter: ASIM,
    motoristaFilter: ASIM,
    codFornecedorFilter: 0,
    codItemEscalaFilter: '',
    codServicoFilter: 0
  };
};

class EnvioWhatsAppFornecedorForm extends Component {
  _isMounted = false;
  intervalId = null;
  safeSetState = safeSetState;

  state = {
    activeTab: 0,
    fornecedoresescalas: [],
    grupoMensagemEnvio: 0,
    gruposmensagem: [],
    isConnected: false,
    labelLoading: '',
    listaFornecedores: [],
    listaServicos: [],
    loading: false,
    marcarTodos: ANAO,
    messageAlert: '',
    onCloseCallback: null,
    openAlert: false,
    prontoEnvio: false,
    qrCode: '',
    searchFilter: getSearchFilterDefault()
  };

  /* Carrega os dados iniciais da tela e inicia o monitoramento da conexão do WhatsApp */
  async componentDidMount() {
    this._isMounted = true;

    this.buscarQrCode();
    this.intervalId = setInterval(this.buscarQrCode, 10000); // consulta a cada 10s

    try {
      const [
        fornecedores,
        servicos,
        gruposmensagem
      ] = await Promise.all([
        api.get('/fornecedor/active/true'),
        api.get('/servico/active/true'),
        api.get('/whatsapp/grupomensagemfornecedor/active/true')
      ]);

      this.safeSetState({
        gruposmensagem: getResponseData(gruposmensagem),
        listaFornecedores: getResponseData(fornecedores),
        listaServicos: getResponseData(servicos)
      });
    } catch (error) {
      this.handleOpenAlert(getApiErrorMessage(error, 'Erro ao carregar os dados da tela!'));
    }
  };

  /* Limpa a flag de montagem e o monitoramento da conexão ao sair da tela */
  componentWillUnmount() {
    this._isMounted = false;

    clearInterval(this.intervalId);
  };

  /* Consulta o status da conexão do WhatsApp (QR Code ou conectado) */
  buscarQrCode = async () => {
    try {
      const { data } = await api.get(`/whatsapp/statusConexaoWhatsApp/${getCodEmpresa()}`);

      if (data.value) {
        this.safeSetState({
          isConnected: false,
          marcarTodos: ANAO,
          prontoEnvio: false,
          qrCode: data.value
        });
      }

      if (data.connected) {
        this.safeSetState({ isConnected: data.connected });
      }
    } catch (error) {
      console.error('Erro ao buscar o QR Code:', error);
    }
  };

  /* Troca a aba ativa */
  handleChangeTab = (event, value) => {
    this.setState({ activeTab: value });
  };

  /* Atualiza o filtro de pesquisa alterado */
  onChangeSearch = (event) => {
    const {
      checked,
      name,
      type,
      value
    } = event.target;

    let adjustedValue = value;

    switch (type) {
      case 'checkbox':
        adjustedValue = checked ? ASIM : ANAO;

        break;
      case 'select-one':
        adjustedValue = Number(value);

        break;
      case 'number':
        adjustedValue = value === '' ? '' : Number(value);

        break;
      default:
        break;
    };

    this.setState(prev => ({
      searchFilter: {
        ...prev.searchFilter,
        [name]: adjustedValue
      }
    }));
  };

  /* Atualiza o fornecedor do filtro de pesquisa */
  onChangeFornecedor = (event, newValue) => {
    this.setState(prev => ({
      searchFilter: {
        ...prev.searchFilter,
        codFornecedorFilter: newValue ? newValue.codfornecedor : 0
      }
    }));
  };

  /* Atualiza o serviço do filtro de pesquisa */
  onChangeServico = (event, newValue) => {
    this.setState(prev => ({
      searchFilter: {
        ...prev.searchFilter,
        codServicoFilter: newValue ? newValue.codservico : 0
      }
    }));
  };

  /* Limpa os filtros de pesquisa */
  limpaFiltros = () => {
    this.setState({ searchFilter: getSearchFilterDefault() });
  };

  /* Pesquisa as escalas dos fornecedores conforme os filtros informados */
  pesquisarFornecedores = async () => {
    const { isConnected, searchFilter } = this.state;

    this.setState({
      labelLoading: 'Filtrando dados...',
      loading: true
    });

    const filtro = {
      guia: searchFilter.guiaFilter,
      fornectransp: searchFilter.fornecTranspFilter,
      motorista: searchFilter.motoristaFilter,
      tipoperiodo: searchFilter.tipoDataFilter,
      datainicial: searchFilter.dataInicialFilter,
      horainicial: searchFilter.horaInicialFilter,
      datafinal: searchFilter.dataFinalFilter,
      horafinal: searchFilter.horaFinalFilter,
      codfornecedor: searchFilter.codFornecedorFilter,
      coditemescala: searchFilter.codItemEscalaFilter,
      codservico: searchFilter.codServicoFilter
    };

    try {
      const response = await api.post(
        `/escala/fornecedoresenviowhatsapp/${getCodEmpresa()}`,
        filtro
      );

      const fornecedores = getResponseData(response).map(item => ({
        ...item,
        marcado: item.existewhatsapp === ASIM && isConnected ? ASIM : ANAO
      }));

      this.safeSetState({
        activeTab: 1,
        fornecedoresescalas: fornecedores,
        marcarTodos: isConnected ? ASIM : ANAO,
        prontoEnvio: isConnected
      });
    } catch (error) {
      this.handleOpenAlert(getApiErrorMessage(error, 'Erro ao pesquisar os fornecedores!'));
    } finally {
      this.safeSetState({ loading: false });
    }
  };

  /* Marca / desmarca o fornecedor da pesquisa */
  onChangeMarcar = (event) => {
    const { checked, value } = event.target;
    const index = Number(value);

    this.setState(prev => ({
      fornecedoresescalas: prev.fornecedoresescalas.map((item, i) => (
        i === index
          ? { ...item, marcado: checked ? item.existewhatsapp : ANAO }
          : item
      ))
    }));
  };

  /* Marca / desmarca todos os fornecedores que possuem WhatsApp */
  onChangeMarcarTodos = (event) => {
    const { checked } = event.target;

    this.setState(prev => ({
      fornecedoresescalas: prev.fornecedoresescalas.map(item => ({
        ...item,
        marcado: checked && item.existewhatsapp === ASIM ? ASIM : ANAO
      })),
      marcarTodos: checked ? ASIM : ANAO
    }));
  };

  /* Atualiza o grupo de mensagens selecionado para envio */
  onChangeGrupoMensagem = (event, newValue) => {
    this.setState({ grupoMensagemEnvio: newValue ? newValue.idgrupomsgwhats : 0 });
  };

  /* Envia as mensagens do grupo selecionado aos fornecedores marcados */
  handleClickEnviar = async () => {
    const { fornecedoresescalas, grupoMensagemEnvio } = this.state;

    if (!grupoMensagemEnvio) {
      this.handleOpenAlert('Por favor, selecione um grupo de mensagens para envio.');

      return;
    }

    const marcados = fornecedoresescalas.filter(item => item.marcado === ASIM);

    if (!marcados.length) {
      this.handleOpenAlert('Marque pelo menos um fornecedor para o envio.');

      return;
    }

    const codEmpresa = getCodEmpresa();
    const codUsuario = getCodUsuarioRegistrou();
    const erros = [];

    this.setState({
      labelLoading: 'Enviando WhatsApp...',
      loading: true
    });

    try {
      for (const fornecedor of marcados) {
        try {
          await api.post(`/whatsapp/enviamensagemwhatsapp/${codEmpresa}`, {
            idgrupomsgwhats: Number(grupoMensagemEnvio),
            codusuarioenviou: codUsuario,
            fornecedor
          });
        } catch (error) {
          erros.push(getApiErrorMessage(error, 'Erro ao enviar mensagem'));
        }
      }
    } finally {
      this.safeSetState({ loading: false });
    }

    const mensagem = erros.length
      ? `Envio concluído com ${erros.length} falha(s): ${erros[0]}`
      : 'Envio concluído.';

    // atualiza a pesquisa após o usuário fechar o alerta
    this.handleOpenAlert(mensagem, this.pesquisarFornecedores);
  };

  /* Desconecta o WhatsApp da empresa */
  handleClickDesconectar = async () => {
    try {
      await api.get(`/whatsapp/desconectarWhatsApp/${getCodEmpresa()}`);

      this.safeSetState({
        isConnected: false,
        marcarTodos: ANAO,
        prontoEnvio: false
      });
    } catch (error) {
      this.handleOpenAlert(getApiErrorMessage(error, 'Erro ao desconectar o WhatsApp!'));
    }
  };

  /* Abre a janela de alerta com mensagem */
  handleOpenAlert = (message, callback) => {
    this.safeSetState({
      messageAlert: message,
      onCloseCallback: callback,
      openAlert: true
    });
  };

  /* Fecha a janela de mensagem com alerta */
  handleCloseAlert = () => {
    const { onCloseCallback } = this.state;

    this.setState({
      onCloseCallback: null,
      openAlert: false
    });

    if (onCloseCallback) {
      onCloseCallback();
    }
  };

  /* Renderiza um combo (Autocomplete) padrão da tela */
  renderAutocomplete = ({ label, ...props }) => (
    <Autocomplete
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="standard"
          style={{ minWidth: 300 }}
        />
      )}
    />
  );

  render() {
    const {
      activeTab,
      fornecedoresescalas,
      grupoMensagemEnvio,
      gruposmensagem,
      isConnected,
      labelLoading,
      listaFornecedores,
      listaServicos,
      loading,
      marcarTodos,
      messageAlert,
      openAlert,
      prontoEnvio,
      qrCode,
      searchFilter
    } = this.state;

    const fornecedorSelecionado = listaFornecedores.find(
      item => item.codfornecedor === searchFilter.codFornecedorFilter
    ) || null;

    const servicoSelecionado = listaServicos.find(
      item => item.codservico === searchFilter.codServicoFilter
    ) || null;

    const grupoSelecionado = gruposmensagem.find(
      item => item.idgrupomsgwhats === grupoMensagemEnvio
    ) || null;

    const estiloMensagem = {
      fontStyle: 'italic',
      color: '#888',
      marginLeft: 5
    };

    return (
      <div style={{ position: 'relative' }}>
        <AppBar
          position="static"
          color="default"
        >
          <Tabs
            value={activeTab}
            onChange={this.handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab
              icon={<FilterListRounded />}
              label="Filtros"
            />

            <Tab
              icon={<SendRounded />}
              label="Envios"
            />

            <Tab
              icon={<CropFreeRounded />}
              label="QR Code"
            />
          </Tabs>
        </AppBar>

        {/* ABA FILTRO */}
        {activeTab === 0 &&
          <TabContainer>
            <CardContent>
              <Paper
                elevation={1}
                style={{
                  marginBottom: 0,
                  marginTop: 0,
                  padding: 10,
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'flex-start',
                  gap: 10
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 10,
                    flex: 1,
                    minWidth: 0
                  }}
                >
                  <FormControl style={{ minWidth: 160 }}>
                    <InputLabel
                      shrink
                      style={{ fontSize: 13 }}
                    >
                      Período
                    </InputLabel>

                    <Select
                      native
                      name="tipoDataFilter"
                      onChange={this.onChangeSearch}
                      value={searchFilter.tipoDataFilter}
                    >
                      <option value={1}>
                        Do serviço
                      </option>

                      <option value={2}>
                        De registro
                      </option>
                    </Select>
                  </FormControl>

                  {GRUPOS_PERIODO.map(grupo => (
                    <div
                      key={grupo[0].name}
                      style={ESTILO_GRUPO_PERIODO}
                    >
                      {grupo.map(campo => (
                        <TextField
                          key={campo.name}
                          id={campo.name}
                          name={campo.name}
                          label={campo.label}
                          type={campo.type}
                          value={searchFilter[campo.name] || ''}
                          onChange={this.onChangeSearch}
                          InputLabelProps={LABEL_PROPS_FILTRO}
                        />
                      ))}
                    </div>
                  ))}
                </div>

                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                    flexShrink: 0,
                    whiteSpace: 'nowrap',
                    alignSelf: 'flex-start',
                    paddingTop: 6
                  }}
                >
                  <Button
                    color="primary"
                    id="pesquisar"
                    onClick={this.pesquisarFornecedores}
                  >
                    <Search />
                  </Button>

                  <Button
                    color="primary"
                    onClick={this.limpaFiltros}
                  >
                    <BackspaceOutlined />
                  </Button>
                </div>
              </Paper>

              <Paper
                elevation={1}
                style={{
                  marginBottom: 0,
                  marginTop: 10,
                  paddingLeft: 10,
                  paddingTop: 10
                }}
              >
                <Typography style={{ fontSize: 12 }}>
                  Categorias
                </Typography>

                <FormGroup row>
                  {CATEGORIAS.map(categoria => (
                    <FormControlLabel
                      key={categoria.name}
                      label={categoria.label}
                      control={
                        <Checkbox
                          checked={searchFilter[categoria.name] === ASIM}
                          name={categoria.name}
                          onChange={this.onChangeSearch}
                          color="primary"
                        />
                      }
                    />
                  ))}
                </FormGroup>
              </Paper>

              <Paper
                elevation={1}
                style={{
                  marginBottom: 0,
                  marginTop: 10,
                  padding: 10,
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'flex-end',
                  gap: 10
                }}
              >
                {this.renderAutocomplete({
                  id: 'combo-fornecedor',
                  label: 'Fornecedor',
                  options: listaFornecedores,
                  getOptionLabel: getFornecedorLabel,
                  value: fornecedorSelecionado,
                  onChange: this.onChangeFornecedor,
                  ...PROPS_COMBO_FILTRO
                })}

                <TextField
                  id="codItemEscalaFilter"
                  name="codItemEscalaFilter"
                  label="Escala"
                  variant="standard"
                  type="number"
                  value={searchFilter.codItemEscalaFilter}
                  onChange={this.onChangeSearch}
                  style={{ width: 100 }}
                />

                {this.renderAutocomplete({
                  id: 'combo-servico',
                  label: 'Serviço',
                  options: listaServicos,
                  getOptionLabel: getServicoLabel,
                  value: servicoSelecionado,
                  onChange: this.onChangeServico,
                  ...PROPS_COMBO_FILTRO
                })}
              </Paper>
            </CardContent>
          </TabContainer>
        }

        {/* ABA ENVIO */}
        {activeTab === 1 &&
          <TabContainer>
            <Box
              display="flex"
              gap={2}
            >
              <FormControl style={{ minWidth: 250 }}>
                {this.renderAutocomplete({
                  label: 'Grupo de mensagens para envio',
                  options: gruposmensagem,
                  getOptionLabel: getGrupoLabel,
                  value: grupoSelecionado,
                  onChange: this.onChangeGrupoMensagem
                })}
              </FormControl>

              <Button
                variant="contained"
                style={{
                  backgroundColor: prontoEnvio ? '#25D366' : '#ccc',
                  color: '#fff',
                  marginLeft: 16
                }}
                startIcon={<WhatsApp style={{ color: '#fff' }} />}
                onClick={this.handleClickEnviar}
                disabled={!prontoEnvio}
              >
                Enviar
              </Button>

              {!isConnected &&
                <Typography
                  variant="body2"
                  style={estiloMensagem}
                >
                  *WhatsApp não conectado
                </Typography>
              }

              {isConnected && fornecedoresescalas.length > 0 && !prontoEnvio &&
                <Typography
                  variant="body2"
                  style={estiloMensagem}
                >
                  *necessário carregar dados novamente para envio
                </Typography>
              }
            </Box>

            <div
              style={{
                marginTop: 10,
                maxHeight: 500,
                overflowY: 'auto',
                borderTop: '2px solid #ccc',
                borderBottom: '2px solid #ccc'
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell style={ESTILO_CABECALHO}>
                      <Checkbox
                        color="primary"
                        checked={marcarTodos === ASIM}
                        onChange={this.onChangeMarcarTodos}
                        disabled={!prontoEnvio}
                      />
                    </TableCell>

                    {COLUNAS_ESCALAS.map(coluna => (
                      <TableCell
                        key={coluna}
                        style={ESTILO_CABECALHO}
                      >
                        <Typography
                          color="textSecondary"
                          component="p"
                          variant="body2"
                        >
                          {coluna}
                        </Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {fornecedoresescalas.map((fornecedor, index) => (
                    <TableRow key={index}>
                      <TableCell
                        align="left"
                        width="1"
                      >
                        <Checkbox
                          color="primary"
                          checked={fornecedor.marcado === ASIM && !!prontoEnvio}
                          onChange={this.onChangeMarcar}
                          value={index}
                          disabled={!prontoEnvio}
                        />
                      </TableCell>

                      <TableCell
                        align="left"
                        width="5"
                      >
                        {fornecedor.categoria}
                      </TableCell>

                      <TableCell
                        align="left"
                        width="5"
                      >
                        {fornecedor.nomefornecedor}
                      </TableCell>

                      <TableCell
                        align="left"
                        width="100"
                        style={{
                          textDecoration: fornecedor.existewhatsapp === ASIM
                            ? 'none'
                            : 'line-through'
                        }}
                      >
                        {fornecedor.fone}
                      </TableCell>

                      <TableCell
                        align="left"
                        width="5"
                      >
                        {fornecedor.coditemescala}
                      </TableCell>

                      <TableCell
                        align="left"
                        width="5"
                      >
                        {formatData(fornecedor.dataservico)}
                      </TableCell>

                      <TableCell
                        align="left"
                        width="5"
                      >
                        {fornecedor.descservico}
                      </TableCell>

                      <TableCell
                        align="center"
                        width="5"
                      >
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          height="100%"
                        >
                          <Box
                            component="span"
                            style={{
                              width: 20,
                              height: 20,
                              borderRadius: '50%',
                              backgroundColor: COR_STATUS[fornecedor.status] || 'white',
                              border: '1px solid #ccc'
                            }}
                          />
                        </Box>
                      </TableCell>

                      <TableCell
                        align="left"
                        width="5"
                      >
                        {fornecedor.descgrupomsgwhats}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>

            <Box
              display="flex"
              alignItems="center"
              mt={2}
            >
              {LEGENDA_STATUS.map((status, index) => (
                <Box
                  key={status.label}
                  display="flex"
                  alignItems="center"
                  mr={index < LEGENDA_STATUS.length - 1 ? 4 : 0}
                >
                  <Box
                    style={{
                      width: 16,
                      height: 16,
                      borderRadius: '50%',
                      backgroundColor: status.backgroundColor,
                      border: status.border,
                      marginRight: 8
                    }}
                  />

                  <Typography
                    variant="body2"
                    style={{ color: 'black' }}
                  >
                    {status.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </TabContainer>
        }

        {/* ABA QR CODE */}
        {activeTab === 2 &&
          <TabContainer>
            {!isConnected ?
              <img
                src={qrCode}
                alt="QR Code"
              /> :
              <Button
                variant="contained"
                style={{
                  backgroundColor: '#9e9e9e',
                  color: '#fff',
                  marginLeft: 16
                }}
                startIcon={<ExitToApp style={{ color: '#fff' }} />}
                onClick={this.handleClickDesconectar}
              >
                Desconectar
              </Button>
            }
          </TabContainer>
        }

        <AlertInformation
          open={openAlert}
          handleClose={this.handleCloseAlert}
          message={messageAlert}
        />

        {loading &&
          <Backdrop
            open={loading}
            style={ESTILO_BACKDROP}
          >
            <CircularProgress color="inherit" />

            <Typography
              variant="subtitle1"
              style={{
                marginTop: 16,
                color: '#454545',
                fontSize: 14
              }}
            >
              {labelLoading}
            </Typography>
          </Backdrop>
        }
      </div>
    );
  };
};

export default EnvioWhatsAppFornecedorForm;